import { render } from "./OrganizationView.vue?vue&type=template&id=d7e64da8&scoped=true"
import script from "./OrganizationView.vue?vue&type=script&lang=js"
export * from "./OrganizationView.vue?vue&type=script&lang=js"

import "./OrganizationView.vue?vue&type=style&index=0&id=d7e64da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e64da8"]])

export default __exports__